import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {QrcodeProcessPage} from '../qrcode-process.page';
import {LoadingController, ModalController, NavController} from '@ionic/angular';
import {ApiService} from '../../../services/api.service';
import {ToastService} from '../../../services/toast.service';
import {ValidateProductModalComponent} from '../../../modal/validate-product-modal/validate-product-modal.component';
import {SearchModalComponent} from '../../../modal/search-modal/search-modal.component';
import {CouleurModalComponent} from '../../../modal/couleur-modal/couleur-modal.component';

@Component({
  selector: 'app-forbiden',
  templateUrl: './forbiden.page.html',
  styleUrls: ['./forbiden.page.scss'],
})
export class ForbidenPage implements OnInit {
  qrcode: any;

  constructor(@Inject(QrcodeProcessPage) private parent: QrcodeProcessPage, private navController: NavController, private apiService: ApiService, private loadingController: LoadingController, private toastService: ToastService, private modalController: ModalController) {
    this.qrcode = this.parent.qrcode;
  }

  ngOnInit() {

  }


  quit() {
    this.navController.navigateBack('/home');
  }

  goBack() {
    this.navController.navigateBack('/home');
  }
}
